import {createStore} from 'vuex'
import VuexPersistence from 'vuex-persist'


//vux数据持久化
const vuexLocal=new VuexPersistence({
    storage:window.localStorage
})



export default createStore({
    state(){
        return{
            logged_in: '',
            menulist:[],
            menuclicknow:'',
            username:'', // 当前主体名称
            main_body_id: '', // 当前主体税号
            current_user: {},
            locationnow:'',
            operationtime:'',   //操作事件
            sfprinttime:'',   //丰桥接口获取token时间
            intervalid:'',      //循环事件id
            basetagslist:{},    //头部tag列表
            baseselectedtag:'',  //当前选择的tag
            pagetagimgurl:'/disney/backui/tags', //页面标签化图片地址
            current_permission: '', // 当前页面的权限模块编号（作为查询页面内容权限的依据）
            ordersearchpagedata:'', //订单查询页面数据
            batchinvoicedata: '',  // 合并开票暂存数据
            mainbody_list: [], // 主体数据缓存
            currentuserextensionno: '', //当前用户分机号  开票申请时的选中值
            exportdate:'',
            orderexportnum:1
        }
    },
    mutations:{
        setLoggedIn(state,logged_in){
            state.logged_in=logged_in
        },
        setCurrentPermission(state,current_permission){
            state.current_permission=current_permission
        },
        setCurrentUser(state,current_user){
            state.current_user=current_user
        },
        setMenulist(state,newmenulist){
            state.menulist=newmenulist
        },
        setMenuclicknow(state,newmenuclicknow){
            state.menuclicknow=newmenuclicknow
        },
        setUsername(state,newusername){
            state.username=newusername
        },
        setMainBodyId(state,main_body_id){
            state.main_body_id=main_body_id
        },
        setLocationnow(state,newlocationnow){
            state.locationnow=newlocationnow
        },
        setOperationtime(state,newoperationtime){
            state.operationtime=newoperationtime
        },
        setSfprinttime(state,newsfprinttime){
            state.sfprinttime=newsfprinttime
        },
        setIntervalid(state,newintervalid){
            state.intervalid=newintervalid
        },
        setBasetagslist(state,newbasetagslist){
            state.basetagslist=newbasetagslist
        },
        setBaseselectedtag(state,newbaseselectedtag){
            state.baseselectedtag=newbaseselectedtag
        },
        setOrdersearchpagedata(state,newordersearchpagedata){
            state.ordersearchpagedata=newordersearchpagedata
        },
        setBatchinvoicedata(state,newbatchinvoicedata){
            state.batchinvoicedata=newbatchinvoicedata
        },
        setMainBodyList(state,mainbody_list){
            state.mainbody_list=mainbody_list
        },
        setCurrentuserextensionno(state,newcurrentuserextensionno){
            state.currentuserextensionno = newcurrentuserextensionno
        },
        setExportdate(state, newexportdate){
            state.exportdate = newexportdate
        },
        setOrderExportnum(state, neworderexportnum){
            state.orderexportnum = neworderexportnum
        }
    },
    plugins:[vuexLocal.plugin]

})